import { makeAutoObservable } from "mobx"
import { v4 as uuidv4 } from "uuid";

const numExp = /^[+-]?\d+(\.\d+)?$/

type IButton = {
    process: boolean
    label: string
}

export  class ButtonStore implements IButton {
    process: boolean = false
    label: string = ""

    constructor() {
        makeAutoObservable(this)
    }

    setAttribute = (name: string, value: string) => {
        let res: any = value
        if (value === "true") res = true
        if (value === "false") res = false
        if (numExp.test(value)) res = parseFloat(value)
        this[name as keyof IButton] = res as never
    }

    onChange = <T extends keyof IButton>(name: T, value: IButton[T]) => {
        this[name] = value as never
    }
}

export  class ButtonsStore {
    values: {[key: string]: ButtonStore} = {}

    constructor() {
        makeAutoObservable(this)
    }

    add = () => {
        const id = uuidv4()
        const state = new ButtonStore()
        this.values[id] = state
        return { id, state }
    }

    find = (id: string) => this.values[id]
}